import { render, staticRenderFns } from "./EventsTemplate.vue?vue&type=template&id=674d2303"
import script from "./EventsTemplate.vue?vue&type=script&lang=js"
export * from "./EventsTemplate.vue?vue&type=script&lang=js"
import style0 from "./EventsTemplate.vue?vue&type=style&index=0&id=674d2303&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports